module.exports = __webpack_public_path__ + "static/media/certificate-gq.32e3f891.png";